import { mapMarkerData, removeMapData } from "@/common/maps/features";
import { getDefaultMarkerOptions } from "@/common/maps/styles";
import { MAP_ICON_COLORS } from "@/common/constants/maps";

export { _addToMap as addToMap };
export { _removeFromMap as removeFromMap };

const _addToMap = (params) => {
  const SOURCE = {
    type: "FeatureCollection",
    features: params.data,
  };
  let iconColor = MAP_ICON_COLORS.disasters;
  if (params.iconColor) {
    iconColor = params.iconColor;
  }

  const PARAMS = {
    id: params.layerId,
    noCluster: false,
    iconColor: iconColor,
  };

  if (params.iconName) {
    PARAMS.iconName = params.iconName;
  }

  let markerOptions = getDefaultMarkerOptions(PARAMS);

  mapMarkerData({
    id: params.layerId,
    data: SOURCE,
    mapClickEvent: params.mapClickEvent,
    markerOptions: markerOptions,
    map: params.map,
    noCluster: false,
    clusterMapClickEvent: params.clusterMapClickEvent,
  });
};

const _removeFromMap = (params) => {
  removeMapData(params.map, params.layerId);
};
